import type { TriageSummaryResponse } from '../data/types';
import { apiFetch, type ApiResponse } from './api';

/**
 * Fetches the triage/enrichment summary for an incident.
 * Returns null if no triage run exists (404).
 */
export async function getTriageSummary(
  tenantId: string,
  incidentId: string
): Promise<ApiResponse<TriageSummaryResponse | null>> {
  const result = await apiFetch<TriageSummaryResponse>(
    `/incidents/${encodeURIComponent(tenantId)}/${encodeURIComponent(incidentId)}/triage`
  );

  if (!result.success) {
    if (result.error?.includes('404')) {
      return { data: null, success: true };
    }
    return { data: null, success: false, error: result.error };
  }

  return { data: result.data, success: true };
}
